import NiceSelect from "nice-select2/dist/js/nice-select2";
document.addEventListener("DOMContentLoaded", function () {
  var blog_select = document.getElementById("blog-select");
  var case_study_select = document.getElementById("case-study-select");
  var case_study_select_2 = document.getElementById("case-study-select-2");
  var careers_select = document.getElementById("careers-select");

  if (blog_select) {
    new NiceSelect(blog_select);
  }

  if (case_study_select) {
    new NiceSelect(case_study_select, {
      placeholder: 'Filter by Category'
    });
  }

  if (case_study_select_2) {
    new NiceSelect(case_study_select_2, {
      placeholder: 'Filter by Sector'
    });
  }

  if (careers_select) {
    new NiceSelect(careers_select, {
      placeholder: 'Job type'
    });
  }
});